import { Modal, useToast } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { ECPDDraftStatus } from 'shared/types/redux/cpd';

import { PrelandingModalContent, PrelandingModalSuccessScreen } from './components';
import { useCPDProps } from './hooks';

export const CPDPrelandingModal: React.FC = () => {
  const toastApi = useToast();
  const {
    cpdDraftStatus,
    isModalOpen,
    phoneValue,
    onPhoneInputChange,
    onGoCianChat,
    onSuccessScreenOpen,
    onModalClose,
    onModalOpen,
    onCreateDraftCpd,
    onCPDLandingLinkClick,
    cpdChatIdLoadingStatus,
    prelandingContentData,
    isDesktop,
    cpdLandingLink,
    isUserAuthenticated,
    handleChangeMarketingAgreement,
    isMarketingAgreement,
  } = useCPDProps();

  React.useEffect(() => {
    if (cpdDraftStatus === ECPDDraftStatus.Fail) {
      toastApi.open({
        text: 'Ошибка, попробуйте ещё раз',
        type: 'error',
        dataTestId: 'CPDPrelandingErrorNotification',
      });
    }
  }, [toastApi, cpdDraftStatus]);

  if (!prelandingContentData || !isModalOpen) {
    return null;
  }

  return (
    <Modal
      size="M"
      open={isModalOpen}
      closeButtonProps={{
        theme: 'fill_light',
        title: 'Закрыть',
        icon: <IconActionClose16 color="current_color" data-testid="cpdModalCloseButton" />,
      }}
      onOpenChange={onModalClose}
      data-testid="CPDPrelandingModal"
    >
      {cpdDraftStatus === ECPDDraftStatus.Success ? (
        <PrelandingModalSuccessScreen
          onGoCianChat={onGoCianChat}
          onModalClose={onModalClose}
          onSuccessScreenOpen={onSuccessScreenOpen}
          cpdChatIdLoadingStatus={cpdChatIdLoadingStatus}
          isMobile={!isDesktop}
          isUserAuthenticated={isUserAuthenticated}
        />
      ) : (
        <PrelandingModalContent
          onModalOpen={onModalOpen}
          onCreateDraftCpd={onCreateDraftCpd}
          onCPDLandingLinkClick={onCPDLandingLinkClick}
          onInputChange={onPhoneInputChange}
          cpdDraftStatus={cpdDraftStatus}
          prelandingContent={prelandingContentData}
          phoneValue={phoneValue}
          isMobile={!isDesktop}
          cpdLandingLink={cpdLandingLink}
          handleChangeMarketingAgreement={handleChangeMarketingAgreement}
          isMarketingAgreement={isMarketingAgreement}
        />
      )}
    </Modal>
  );
};
